const messages = {
  en: {
    registroActividad: {
      title: "Activity Log",
      menuTitle: "Activity Log",
      subtitle: "View and filter user actions",
      labels: {
        fecha: "Date",
        usuario: "User",
        destacable: "Alert",
        accion: "Action",
        entidad: "Entity",
        detalles: "Details",
        deposito: "Deposit",
        datosCreados: "Created data",
        datosRecurso: "Resource data",
        productosModificados: "Modified products",
        criteriosOferta: "Offer criteria",
        creadoPor: "Created by",
        createdAt: "Created at",
        updatedAt: "Updated at",
      },
      destacable: {
        defaultReason: "Alert activity",
      },
      actions: {
        CREATE: "Create",
        UPDATE: "Modify",
        UPDATE_MANY: "Bulk modify",
        DELETE: "Delete",
        LOGIN: "Login",
      },
      filters: {
        usuario: "User",
        accion: "Action",
        entidad: "Entity",
        desde: "From",
        hasta: "To",
      },
    },
  },
  es: {
    registroActividad: {
      title: "Registro de Actividades",
      menuTitle: "Registro de Actividades",
      subtitle: "Ver y filtrar acciones de usuarios",
      labels: {
        fecha: "Fecha",
        usuario: "Usuario",
        destacable: "Alerta",
        accion: "Acción",
        entidad: "Entidad",
        detalles: "Detalles",
        deposito: "Depósito",
        datosCreados: "Datos creados",
        datosRecurso: "Datos del recurso",
        productosModificados: "Productos modificados",
        criteriosOferta: "Criterios de la oferta",
        creadoPor: "Creado por",
        createdAt: "Creado el",
        updatedAt: "Actualizado el",
      },
      destacable: {
        defaultReason: "Actividad en alerta",
      },
      actions: {
        CREATE: "Crear",
        UPDATE: "Modificar",
        UPDATE_MANY: "Modificación masiva",
        DELETE: "Eliminar",
        LOGIN: "Login",
      },
      filters: {
        usuario: "Usuario",
        accion: "Acción",
        entidad: "Entidad",
        desde: "Desde",
        hasta: "Hasta",
      },
    },
  },
};

export default messages;
